import { memo, useEffect, useRef } from "react";

const PARTICLE_COUNT = 48;

const spawnParticle = (width, height) => {
  const fromBottom = Math.random() < 0.62;
  return {
    x: fromBottom
      ? Math.random() * width
      : Math.random() < 0.5
        ? Math.random() * width * 0.22
        : width * 0.78 + Math.random() * width * 0.22,
    y: fromBottom ? height * (0.55 + Math.random() * 0.45) : Math.random() * height,
    vx: (Math.random() - 0.5) * 0.45,
    vy: -0.25 - Math.random() * 0.95,
    r: 0.8 + Math.random() * 2.6,
    life: 0.45 + Math.random() * 0.55,
    decay: 0.0035 + Math.random() * 0.007,
    hue: Math.random() > 0.35 ? [255, 118, 32] : [255, 204, 92],
  };
};

const GiftPopupEmbers = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const ctx = canvas.getContext("2d");
    if (!ctx) return undefined;

    let frameId = 0;
    let particles = [];
    const parent = canvas.parentElement;

    const resize = () => {
      if (!parent) return;
      const ratio = window.devicePixelRatio || 1;
      const width = parent.clientWidth;
      const height = parent.clientHeight;
      canvas.width = Math.max(1, Math.floor(width * ratio));
      canvas.height = Math.max(1, Math.floor(height * ratio));
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      particles = Array.from({ length: PARTICLE_COUNT }, () => spawnParticle(width, height));
    };

    resize();
    const observer = new ResizeObserver(resize);
    if (parent) observer.observe(parent);

    const draw = () => {
      const width = parent?.clientWidth || 0;
      const height = parent?.clientHeight || 0;
      ctx.clearRect(0, 0, width, height);

      particles.forEach((particle, index) => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        particle.life -= particle.decay;

        if (particle.life <= 0 || particle.y < -8) {
          particles[index] = spawnParticle(width, height);
          return;
        }

        const alpha = Math.max(0, particle.life);
        ctx.beginPath();
        ctx.shadowBlur = 10;
        ctx.shadowColor = `rgba(${particle.hue[0]}, ${particle.hue[1]}, ${particle.hue[2]}, ${alpha})`;
        ctx.fillStyle = `rgba(${particle.hue[0]}, ${particle.hue[1]}, ${particle.hue[2]}, ${alpha})`;
        ctx.arc(particle.x, particle.y, particle.r, 0, Math.PI * 2);
        ctx.fill();
      });

      frameId = window.requestAnimationFrame(draw);
    };

    frameId = window.requestAnimationFrame(draw);

    return () => {
      window.cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, []);

  return <canvas ref={canvasRef} className="gift-popup-embers" aria-hidden="true" />;
};

export default memo(GiftPopupEmbers);
